/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertSearchOverride
 */
export interface UpsertSearchOverride {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertSearchOverride
     */
    documentIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpsertSearchOverride
     */
    hostname: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertSearchOverride
     */
    name: string;
}

/**
 * Check if a given object implements the UpsertSearchOverride interface.
 */
export function instanceOfUpsertSearchOverride(value: object): value is UpsertSearchOverride {
    if (!('documentIds' in value) || value['documentIds'] === undefined) return false;
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpsertSearchOverrideFromJSON(json: any): UpsertSearchOverride {
    return UpsertSearchOverrideFromJSONTyped(json, false);
}

export function UpsertSearchOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertSearchOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'documentIds': json['documentIds'],
        'hostname': json['hostname'],
        'name': json['name'],
    };
}

export function UpsertSearchOverrideToJSON(value?: UpsertSearchOverride | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'documentIds': value['documentIds'],
        'hostname': value['hostname'],
        'name': value['name'],
    };
}

